/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, orderNumber: NonNullable<unknown> }} Orders_Delete_Document_SuccessInputs */

const en_orders_delete_document_success = /** @type {(inputs: Orders_Delete_Document_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deleted ${i?.label} from order ${i?.orderNumber}.`)
};

const es_orders_delete_document_success = /** @type {(inputs: Orders_Delete_Document_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se eliminó ${i?.label} del pedido ${i?.orderNumber}.`)
};

/**
* | output |
* | --- |
* | "Deleted {label} from order {orderNumber}." |
*
* @param {Orders_Delete_Document_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_delete_document_success = /** @type {((inputs: Orders_Delete_Document_SuccessInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Delete_Document_SuccessInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_delete_document_success(inputs)
	return es_orders_delete_document_success(inputs)
});